// Tailwind classes only (no custom CSS), mapped from the design's stage
// palette onto Chatwoot's existing next-gen color tokens.
export const STAGES = {
  pre: { badge: 'bg-n-slate-4 text-n-slate-11', dot: 'bg-n-slate-11' },
  active: { badge: 'bg-n-blue-4 text-n-blue-11', dot: 'bg-n-blue-11' },
  uc: { badge: 'bg-n-amber-4 text-n-amber-11', dot: 'bg-n-amber-11' },
  closed: { badge: 'bg-n-teal-4 text-n-teal-11', dot: 'bg-n-teal-11' },
  vacant: { badge: 'bg-n-ruby-4 text-n-ruby-11', dot: 'bg-n-ruby-11' },
  leased: { badge: 'bg-n-iris-4 text-n-iris-11', dot: 'bg-n-iris-11' },
};

export const STAGE_ORDER = ['pre', 'active', 'uc', 'closed', 'vacant', 'leased'];

// Locale-aware month formatting (falls back to the browser's own locale
// detection when none is supplied) instead of a hardcoded English list.
export const monthLabel = (ym, locale) => {
  if (!ym) return '';
  const [year, month] = ym.split('-').map(Number);
  const date = new Date(year, month - 1, 1);
  return new Intl.DateTimeFormat(locale, { month: 'short', year: 'numeric' }).format(date);
};

export const formatMoney = (amount, compact = true) => {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return '—';
  if (!compact) return `$${amount.toLocaleString('en-US')}`;
  if (amount >= 1e6) {
    const value = (amount / 1e6).toFixed(amount >= 1e7 ? 1 : 2);
    return `$${value.replace(/\.?0+$/, '')}M`;
  }
  return `$${Math.round(amount / 1000)}K`;
};
